export default "__VITE_ASSET__CbFL5apE__"